import { useQueryCandidateInfo } from "@/api/candidate/candidate";
import { Alert, AlertDescription, AlertTitle } from "@/components/atoms/Alert";
import { Button } from "@/components/atoms/Button";
import BirthNameDialog from "@/components/molecules/PersonalInfoForm/BirthNameDialog";
import { AlertCircle, ArrowRight } from "lucide-react";
import { useState } from "react";

const BirthNameAlert = () => {
  const { data: candidate } = useQueryCandidateInfo();
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!candidate || candidate.personalInfo.birthName) return null;

  return (
    <>
      <BirthNameDialog isOpen={dialogOpen} close={() => setDialogOpen(false)} />
      <Alert variant="orange">
        <AlertCircle className="h-5 w-5 stroke-white" />
        <AlertTitle className="ml-2">
          Votre nom de naissance n’est pas encore renseigné
        </AlertTitle>
        <AlertDescription className="font-normal ml-2">
          Il est nécessaire pour vous inscrire à une nouvelle session d’examen
        </AlertDescription>
        <Button
          className="absolute top-4 right-3 bg-white border rounded-lg text-[#EA580C] gap-2 hover:text-white hover:bg-[#EA580C] hover:border-white"
          onClick={() => setDialogOpen(true)}
        >
          Renseigner mon nom de naissance
          <ArrowRight className="w-5 h-5" />
        </Button>
      </Alert>
    </>
  );
};

export default BirthNameAlert;
